export const validateEmail = (email) => {
  if (!email) {
    return "Email is required";
  } else if (!/\S+@\S+\.\S+/.test(email)) {
    return "Email is invalid";
  }
  return "";
};
export const ALLOWED_EMAIL_DOMAIN = "@flexcellence.co";

export const validateFlexEmail = (email) => {
  if (!email) {
    return "Email is required";
  } else if (!email.toLowerCase().endsWith(ALLOWED_EMAIL_DOMAIN)) {
    return `Email must end with ${ALLOWED_EMAIL_DOMAIN}`;
  }
  return "";
};
export const validateEmailWithFlexDomain = (email) => {
  const emailError = validateEmail(email);
  if (emailError) return emailError;
  const flexError = validateFlexEmail(email);
  if (flexError) return flexError;
  return "";
};


export const validatePassword = (password) => {
  if (!password) {
    return "Password is required";
  } else if (password.length < 6) {
    return "Password must be at least 6 characters";
  }
  return "";
};

export function formatDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export const updateVisibleDates = (width = 120) => {
  const screenWidth = window.innerWidth;
  const dateWidth = width;
  const numberOfDates = Math.max(7, Math.floor(screenWidth / dateWidth));

  const dates = [];
  const today = new Date();
  for (let i = 0; i < numberOfDates; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() - i);
    dates.push(date);
  }
  return dates.reverse();
};

export const validatePhoneNumber = (phone) => {
  if (!phone) {
    return "Phone number is required";
  } else if (!/^\+?[0-9]{10,15}$/.test(phone)) {
    return "Invalid phone number format add +1 or +91 before the number no spaces ";
  }
  return "";
};
